/**
 * Weapon ids, in a module of their own without imports: the other modules use them at load time, and the
 * modules of the arsenal import each other (weapons, arsenal, chests, mines...).
 */
export const WEAPON_BAZOOKA = 0;
export const WEAPON_GRENADE = 1;
export const WEAPON_PISTOL = 2;
export const WEAPON_SANDBAG = 3;
/** Chest weapons (GDD section 8, "Armes de coffre") built so far. */
export const WEAPON_DRILL = 4;
export const WEAPON_MINE = 5;
/** La Vague: base arsenal (2 per team). */
export const WEAPON_WAVE = 6;
/** Lance-flammes: base arsenal (2 per team), a jet while the button is held. */
export const WEAPON_FLAMER = 7;
/** Cocktail d'huile: chest weapon, a bottle of burning oil. */
export const WEAPON_COCKTAIL = 8;
/** Chest weapons of waves 3-4: cold. */
export const WEAPON_CRYO = 9;
export const WEAPON_ICE_MINE = 10;
export const WEAPON_METEOR = 11;
/** Rare chest weapons (GDD section 8). */
export const WEAPON_LASER = 12;
export const WEAPON_GEYSER = 13;
export const WEAPON_DOLL = 14;
/** Epic: lifts a 32 × 32 square of the map and puts it down elsewhere. */
export const WEAPON_REMOTE = 15;
/** Jetpack: base arsenal (author's addition, 2 per team); flying is not the turn's shot. */
export const WEAPON_JETPACK = 16;
/** Batterie: base arsenal (author's addition, 1 per team), thrown; an electric discharge at the start of every turn. */
export const WEAPON_BATTERY = 17;
/** Barrels that roll and leave a trail (author's addition, barrel.ts). */
export const WEAPON_ACID_BARREL = 18;
export const WEAPON_POWDER_BARREL = 19;
/** Volcan de poche (author's addition, volcano.ts): put like the geyser, it erupts for 3 turns and melts into lava. */
export const WEAPON_VOLCANO = 20;
/** Roomba (author's addition, roomba.ts): it walks about and swallows all that is not solid, with a whirlwind like Kirby's. */
export const WEAPON_ROOMBA = 21;
/** Not a weapon: a lava bomb of the volcano's eruption (Île de Braise), flying as a projectile. */
export const PROJ_LAVA_BOMB = 64;
/** Not a weapon: a drop of acid sprayed by a burst acid barrel. */
export const PROJ_ACID_DROP = 65;
